import Currency from "slotworks/i18n/currency";
import Translations from "slotworks/i18n/translations";

export function formatMoney(value: number): string {
    return Currency.format(value);
}

export function formatMoneyAsCurrency(value: number): string {
    return Currency.format(value, undefined, false);
}

export function formatMoneyAsCoins(value: number): string {
    return Currency.format(value, undefined, true);
}

export function formatMinutes(value: number): string {
    const minutes = value % 60;
    const hours = Math.floor(value / 60);

    if (hours > 0) {
        if (minutes > 0) {
            return printHours(hours) + " " + printMinutes(minutes);
        } else {
            return printHours(hours);
        }
    } else {
        return printMinutes(minutes);
    }
}

function printHours(n: number) {
    if (n === 1) {
        return n + " " + Translations.get("gen.hour");
    } else {
        return n + " " + Translations.get("gen.hours");
    }
}

function printMinutes(n: number) {
    if (n === 1) {
        return n + " " + Translations.get("gen.minute");
    } else {
        return n + " " + Translations.get("gen.minutes");
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/utils/string-formatters.ts